import TextField, { TextFieldProps } from '@mui/material/TextField';
import { OutlinedInputProps } from '@mui/material/OutlinedInput';
import { styled } from '@mui/material/styles';

export const InputText = styled((props: TextFieldProps) => (
  <TextField
    InputLabelProps={{ shrink: true }}
    variant="outlined"
    {...props}
  />
))(({ theme }) => ({
  '&': {
    borderRadius: '4px',
    paddingTop: '4px',
    paddingBottom: '4px',
    position: 'relative',
    marginBottom: '8px'
  },
  '& .MuiFormLabel-root': {
    position: 'static',
    transform: 'none',
    marginBottom: '8px',
    color: '#333333',
    fontSize: '12px',
    lineHeight: '16px',
    paddingLeft: '12px'
  },
  '& .MuiOutlinedInput-root': {
    overflow: 'hidden',
    borderRadius: '4px',
    backgroundColor: '#fff',
    border: '1px solid',
    borderColor: '#CCCCCC',
    transition: theme.transitions.create([
      'border-color',
      'background-color',
      'box-shadow',
    ]),
    '&:hover': {
      backgroundColor: '#fff',
    },
    '&.Mui-focused': {
      backgroundColor: '#fff',
      borderColor: theme.palette.primary.main,
    },
    '&.Mui-error': {
      borderColor: '#EB5757',
    },
    '& .MuiInputBase-input': {
      paddingLeft: '12px',
      paddingTop: '8px',
      paddingBottom: '8px'
    },
  },
  '.MuiFormLabel-asterisk': {
    display: 'none',
  },
  '.MuiFormHelperText-root': {
    fontSize: '14px',
    color: theme.palette.error.main
  },
  '.MuiFormHelperText-contained': {
    // position: 'absolute',
    bottom: '-12px',
  },
  '.MuiOutlinedInput-notchedOutline': {
    display: 'none',
  }
}));